import axios from "axios"
import { Message, MessageBox } from "element-ui"
import store from "@/store"
import { getToken } from "@/utils/auth"

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
  //配置请求头，每次请求都加上X-API-KEY请求头,在服务端验证,这是在RestController中自动实现的，基于keys表，把X-API-KEY获取之后跟表中的比较
  headers: { "X-API-KEY": "oocwo8cs88g4c8w8c08ow00ss844cc4osko0s0ks" }
})

//request interceptor
service.interceptors.request.use(
  config => {
    //store是挂载到 this.$store 对象下的, 因此每次关闭tab页，然后再进入，这个$store对象就是默认值，而这里的token是getToken从本地获取的
    //console.log(store.getters.token)
    //配置请求头，请求时加上X-Token请求头字段,第一次登录login请求的时候不带这个请求头
    if (store.getters.token) {
      config.headers["X-Token"] = getToken()
    }

    return config
  },
  error => {
    Promise.reject(error)
  }
)
//response interceptor
// 50014 token过期
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code != 20000) {
      if (res.code === 50016) {
        Message({
          message: res.message,
          type: "error",
          duration: 3 * 1000
        })
      }
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm("你已被登出，可以取消继续留在该页面，或者重新登录", "确定登出", {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            store.dispatch("Logout").then(() => {
              location.reload()
              //window.location.reload() //新实例化vue-router对象 避免bug
            })
          })
          .catch(() => {
            Message({
              message: "你取消了操作",
              type: "error",
              duration: 3 * 1000
            })
          })
      }
      //考虑不周全
      //return Promise.reject("error")
      return response.data
    } else {
      return response.data
    }
  },
  error => {
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
